import { Environment } from './types/Environment';

export const CURRENT_ENV: Environment = 'PROD';
export const EMULATION_MODE: 'EMULATE_NONE' | 'EMULATE_ALL' | 'EMULATE_FUNCTIONS' = 'EMULATE_NONE';
export const apiMapping = {
  "createOneAgency": {
    "functionName": "createOneAgency",
    "path": "https://prod.apistayopen.com/companies/:companyId/agencies/create",
    "verb": "POST",
    "authType": "JWT"
  },
  "getAllAgencies": {
    "functionName": "getAllAgencies",
    "path": "https://prod.apistayopen.com/agencies",
    "verb": "GET",
    "authType": "JWT"
  },
  "getAllAgenciesByCompanyId": {
    "functionName": "getAllAgenciesByCompanyId",
    "path": "https://prod.apistayopen.com/companies/:companyId/agencies",
    "verb": "GET",
    "authType": "JWT"
  },
  "getAllAgenciesOfAgencyAdmin": {
    "functionName": "getAllAgenciesOfAgencyAdmin",
    "path": "https://prod.apistayopen.com/companies/:companyId/agency-admin/:agencyAdminId/agencies",
    "verb": "GET",
    "authType": "JWT"
  },
  "getAllAgenciesPerPage": {
    "functionName": "getAllAgenciesPerPage",
    "path": "https://prod.apistayopen.com/agencies/paginate",
    "verb": "POST",
    "authType": "JWT"
  },
  "getExportingAllAgencies": {
    "functionName": "getExportingAllAgencies",
    "path": "https://prod.apistayopen.com/agencies/export",
    "verb": "GET",
    "authType": "JWT"
  },
  "getOneAgency": {
    "functionName": "getOneAgency",
    "path": "https://prod.apistayopen.com/agencies/:agencyId",
    "verb": "GET",
    "authType": "JWT"
  },
  "updateOneAgency": {
    "functionName": "updateOneAgency",
    "path": "https://prod.apistayopen.com/companies/:companyId/agencies/:agencyId/update",
    "verb": "POST",
    "authType": "JWT"
  },
  "getBeneficiaryClassificationForAgency": {
    "functionName": "getBeneficiaryClassificationForAgency",
    "path": "https://prod.apistayopen.com/companies/:companyId/agencies/:agencyId/beneficiary-classification",
    "verb": "GET",
    "authType": "JWT"
  },
  "getAllAgencyManagementUnits": {
    "functionName": "getAllAgencyManagementUnits",
    "path": "https://prod.apistayopen.com/agencies/:agencyId/management-unit",
    "verb": "GET",
    "authType": "JWT"
  },
  "createOneAgencyManagementUnit": {
    "functionName": "createOneAgencyManagementUnit",
    "path": "https://prod.apistayopen.com/agencies/:agencyId/management-unit/create",
    "verb": "POST",
    "authType": "JWT"
  },
  "updateOneAgencyManagementUnit": {
    "functionName": "updateOneAgencyManagementUnit",
    "path": "https://prod.apistayopen.com/agencies/:agencyId/management-unit/update",
    "verb": "POST",
    "authType": "JWT"
  },
  "removeOneAgencyManagementUnit": {
    "functionName": "removeOneAgencyManagementUnit",
    "path": "https://prod.apistayopen.com/agencies/:agencyId/management-unit/remove",
    "verb": "POST",
    "authType": "JWT"
  },
  "createOneAgencyOrganization": {
    "functionName": "createOneAgencyOrganization",
    "path": "https://prod.apistayopen.com/agencies/:agencyId/organization/create",
    "verb": "POST",
    "authType": "JWT"
  },
  "updateOneAgencyOrganization": {
    "functionName": "updateOneAgencyOrganization",
    "path": "https://prod.apistayopen.com/agencies/:agencyId/organization/update",
    "verb": "POST",
    "authType": "JWT"
  },
  "removeOneAgencyOrganization": {
    "functionName": "removeOneAgencyOrganization",
    "path": "https://prod.apistayopen.com/agencies/:agencyId/organization/remove",
    "verb": "POST",
    "authType": "JWT"
  },
  "importAgenciesOrganizationInformations": {
    "functionName": "importAgenciesOrganizationInformations",
    "path": "https://prod.apistayopen.com/agencies/import/organization-informations",
    "verb": "POST",
    "authType": "JWT"
  },
  "uploadAgencyLogo": {
    "functionName": "uploadAgencyLogo",
    "path": "https://prod.apistayopen.com/agencies/:agencyId/upload-logo",
    "verb": "POST",
    "authType": "JWT"
  },
  "createAgencyAdmin": {
    "functionName": "createAgencyAdmin",
    "path": "https://prod.apistayopen.com/companies/:companyId/agencies/:agencyId/agency-admin/create",
    "verb": "POST",
    "authType": "JWT"
  },
  "updateAgencyAdmin": {
    "functionName": "updateAgencyAdmin",
    "path": "https://prod.apistayopen.com/companies/:companyId/agencies/:agencyId/agency-admin/:agencyAdminId/update",
    "verb": "POST",
    "authType": "JWT"
  },
  "deactivateAgencyAdmin": {
    "functionName": "deactivateAgencyAdmin",
    "path": "https://prod.apistayopen.com/companies/:companyId/agencies/:agencyId/agency-admin/:agencyAdminId/deactivate",
    "verb": "POST",
    "authType": "JWT"
  },
  "getAllAgencyAdmins": {
    "functionName": "getAllAgencyAdmins",
    "path": "https://prod.apistayopen.com/companies/:companyId/agencies/:agencyId/agency-admin/get",
    "verb": "GET",
    "authType": "JWT"
  },
  "getConnectedAgencyAdmin": {
    "functionName": "getConnectedAgencyAdmin",
    "path": "https://prod.apistayopen.com/connected/agency-admin",
    "verb": "GET",
    "authType": "JWT"
  },
  "getOneAgencyAdminByEmail": {
    "functionName": "getOneAgencyAdminByEmail",
    "path": "https://prod.apistayopen.com/agency-admin/get-by-email",
    "verb": "POST",
    "authType": "JWT"
  },
  "getAllManagementUnitsSettingsOfAgencyAdmin": {
    "functionName": "getAllManagementUnitsSettingsOfAgencyAdmin",
    "path": "https://prod.apistayopen.com/agencies/:agencyId/agency-admin/:agencyAdminId/settings/management-units",
    "verb": "GET",
    "authType": "JWT"
  },
  "associateAgencyAdminWithAgencyManagementUnit": {
    "functionName": "associateAgencyAdminWithAgencyManagementUnit",
    "path": "https://prod.apistayopen.com/agencies/:agencyId/agency-admin/:agencyAdminId/settings/management-units/associate",
    "verb": "POST",
    "authType": "JWT"
  },
  "changePasswordForAgencyAdmin": {
    "functionName": "changePasswordForAgencyAdmin",
    "path": "https://prod.apistayopen.com/auth/agency-admin/change-password",
    "verb": "POST",
    "authType": "NONE"
  },
  "changePasswordForBeneficiary": {
    "functionName": "changePasswordForBeneficiary",
    "path": "https://prod.apistayopen.com/auth/beneficiary/change-password",
    "verb": "POST",
    "authType": "JWT"
  },
  "changePasswordForSuperAdmin": {
    "functionName": "changePasswordForSuperAdmin",
    "path": "https://prod.apistayopen.com/auth/super-admin/change-password",
    "verb": "POST",
    "authType": "JWT"
  },
  "createPinForBeneficiary": {
    "functionName": "createPinForBeneficiary",
    "path": "https://prod.apistayopen.com/auth/beneficiary/create-pin",
    "verb": "POST",
    "authType": "NONE"
  },
  "loginForBeneficiaryWithPin": {
    "functionName": "loginForBeneficiaryWithPin",
    "path": "https://prod.apistayopen.com/auth/beneficiary/login-with-pin",
    "verb": "POST",
    "authType": "NONE"
  },
  "loginForSuperAdmin": {
    "functionName": "loginForSuperAdmin",
    "path": "https://prod.apistayopen.com/super-admin/login",
    "verb": "POST",
    "authType": "NONE"
  },
  "regeneratePasswordForOpenAdmin": {
    "functionName": "regeneratePasswordForOpenAdmin",
    "path": "https://prod.apistayopen.com/users/:userId/regenerate-password",
    "verb": "POST",
    "authType": "JWT"
  },
  "requestPasswordChangeForAgencyAdmin": {
    "functionName": "requestPasswordChangeForAgencyAdmin",
    "path": "https://prod.apistayopen.com/agency-admin/forgot-password",
    "verb": "POST",
    "authType": "NONE"
  },
  "validateHashForAgencyAdmin": {
    "functionName": "validateHashForAgencyAdmin",
    "path": "https://prod.apistayopen.com/auth/agency-admin/validate-hash",
    "verb": "POST",
    "authType": "NONE"
  },
  "createOneCompany": {
    "functionName": "createOneCompany",
    "path": "https://prod.apistayopen.com/companies/create",
    "verb": "POST",
    "authType": "JWT"
  },
  "getAllCompanies": {
    "functionName": "getAllCompanies",
    "path": "https://prod.apistayopen.com/companies",
    "verb": "GET",
    "authType": "JWT"
  },
  "getAllCompaniesPaginated": {
    "functionName": "getAllCompaniesPaginated",
    "path": "https://prod.apistayopen.com/companies/paginated",
    "verb": "POST",
    "authType": "JWT"
  },
  "getOneCompany": {
    "functionName": "getOneCompany",
    "path": "https://prod.apistayopen.com/companies/:companyId",
    "verb": "GET",
    "authType": "JWT"
  },
  "getOneCompanyByName": {
    "functionName": "getOneCompanyByName",
    "path": "https://prod.apistayopen.com/companies/company-name",
    "verb": "POST",
    "authType": "JWT"
  },
  "updateOneCompany": {
    "functionName": "updateOneCompany",
    "path": "https://prod.apistayopen.com/companies/:companyId/update",
    "verb": "POST",
    "authType": "JWT"
  },
  "getAllBouncesPerPage": {
    "functionName": "getAllBouncesPerPage",
    "path": "https://prod.apistayopen.com/email-event/bounces",
    "verb": "POST",
    "authType": "JWT"
  },
  "resendInvitationEmailAndUpdateBounceSendStatus": {
    "functionName": "resendInvitationEmailAndUpdateBounceSendStatus",
    "path": "https://prod.apistayopen.com/email-event/bounces/:emailEventId/resend-and-update",
    "verb": "POST",
    "authType": "JWT"
  },
  "catchEmailEventsWebhook": {
    "functionName": "catchEmailEventsWebhook",
    "path": "https://prod.apistayopen.com/webhooks/email-event",
    "verb": "POST",
    "authType": "NONE"
  },
  "sendEmail": {
    "functionName": "sendEmail",
    "path": "https://prod.apistayopen.com/email/send",
    "verb": "POST",
    "authType": "JWT"
  },
  "sendInvitationEmailToBeneficiary": {
    "functionName": "sendInvitationEmailToBeneficiary",
    "path": "https://prod.apistayopen.com/email/beneficiary/invitation",
    "verb": "POST",
    "authType": "JWT"
  },
  "sendMailsToUnOnboardedBeneficiaries": {
    "functionName": "sendMailsToUnOnboardedBeneficiaries",
    "path": "https://prod.apistayopen.com/email/unonboarded/invitation",
    "verb": "POST",
    "authType": "JWT"
  },
  "sendResetPasswordEmailToAgencyAdmin": {
    "functionName": "sendResetPasswordEmailToAgencyAdmin",
    "path": "https://prod.apistayopen.com/email/agency-admin/reset-password",
    "verb": "POST",
    "authType": "JWT"
  },
  "sendResyncBridgeCredentialsEmail": {
    "functionName": "sendResyncBridgeCredentialsEmail",
    "path": "https://prod.apistayopen.com/email/resync/invitation",
    "verb": "POST",
    "authType": "JWT"
  },
  "acceptBeneficiaryCgu": {
    "functionName": "acceptBeneficiaryCgu",
    "path": "https://prod.apistayopen.com/beneficiary/:beneficiaryId/accept-cgu",
    "verb": "POST",
    "authType": "JWT"
  },
  "createBeneficiaryPan": {
    "functionName": "createBeneficiaryPan",
    "path": "https://prod.apistayopen.com/beneficiaries/:beneficiaryId/pans/create",
    "verb": "POST",
    "authType": "JWT"
  },
  "createOneBeneficiary": {
    "functionName": "createOneBeneficiary",
    "path": "https://prod.apistayopen.com/agencies/:agencyId/beneficiaries/create",
    "verb": "POST",
    "authType": "JWT"
  },
  "manageBeneficiaryDeactivationSchedule": {
    "functionName": "manageBeneficiaryDeactivationSchedule",
    "path": "https://prod.apistayopen.com/beneficiaries/:beneficiaryId/manageDeactivationSchedule",
    "verb": "POST",
    "authType": "JWT"
  },
  "deleteBeneficiaryPan": {
    "functionName": "deleteBeneficiaryPan",
    "path": "https://prod.apistayopen.com/beneficiaries/:beneficiaryId/pans/:panId/delete",
    "verb": "POST",
    "authType": "JWT"
  },
  "getAllBeneficiaries": {
    "functionName": "getAllBeneficiaries",
    "path": "https://prod.apistayopen.com/beneficiaries",
    "verb": "POST",
    "authType": "JWT"
  },
  "getAllBeneficiariesByAgencyId": {
    "functionName": "getAllBeneficiariesByAgencyId",
    "path": "https://prod.apistayopen.com/agencies/:agencyId/beneficiaries",
    "verb": "GET",
    "authType": "JWT"
  },
  "getBeneficiariesByFilters": {
    "functionName": "getBeneficiariesByFilters",
    "path": "https://prod.apistayopen.com/beneficiaries/search",
    "verb": "POST",
    "authType": "JWT"
  },
  "getBeneficiariesCountByAgencyId": {
    "functionName": "getBeneficiariesCountByAgencyId",
    "path": "https://prod.apistayopen.com/agencies/:agencyId/beneficiaries/count",
    "verb": "GET",
    "authType": "JWT"
  },
  "getBeneficiaryPans": {
    "functionName": "getBeneficiaryPans",
    "path": "https://prod.apistayopen.com/beneficiaries/:beneficiaryId/pans/get",
    "verb": "GET",
    "authType": "JWT"
  },
  "getExportingAllBeneficiaries": {
    "functionName": "getExportingAllBeneficiaries",
    "path": "https://prod.apistayopen.com/beneficiaries/export",
    "verb": "GET",
    "authType": "JWT"
  },
  "getExportingBeneficiaryBalances": {
    "functionName": "getExportingBeneficiaryBalances",
    "path": "https://prod.apistayopen.com/beneficiaries/:beneficiaryId/balances/export",
    "verb": "POST",
    "authType": "JWT"
  },
  "getExportingBeneficiaryDetail": {
    "functionName": "getExportingBeneficiaryDetail",
    "path": "https://prod.apistayopen.com/beneficiaries/:beneficiaryId/details/export",
    "verb": "POST",
    "authType": "JWT"
  },
  "getBeneficiariesOpenBankingKO": {
    "functionName": "getBeneficiariesOpenBankingKO",
    "path": "https://prod.apistayopen.com/admin/beneficiaries/open-banking-ko",
    "verb": "POST",
    "authType": "JWT"
  },
  "getFullBeneficiaryByIdForAdmin": {
    "functionName": "getFullBeneficiaryByIdForAdmin",
    "path": "https://prod.apistayopen.com/admin/beneficiaries/:beneficiaryId/full",
    "verb": "POST",
    "authType": "JWT"
  },
  "getOneBeneficiaryByIdForAdmin": {
    "functionName": "getOneBeneficiaryByIdForAdmin",
    "path": "https://prod.apistayopen.com/admin/beneficiaries/:beneficiaryId/get",
    "verb": "GET",
    "authType": "JWT"
  },
  "changeBeneficiaryMode": {
    "functionName": "changeBeneficiaryMode",
    "path": "https://prod.apistayopen.com/beneficiaries/:beneficiaryId/change-mode",
    "verb": "POST",
    "authType": "JWT"
  },
  "resetBeneficiaryMode": {
    "functionName": "resetBeneficiaryMode",
    "path": "https://prod.apistayopen.com/beneficiaries/:beneficiaryId/reset-mode",
    "verb": "POST",
    "authType": "JWT"
  },
  "resetBeneficiaryOpenBankingSync": {
    "functionName": "resetBeneficiaryOpenBankingSync",
    "path": "https://prod.apistayopen.com/beneficiaries/:beneficiaryId/reset-sync",
    "verb": "POST",
    "authType": "JWT"
  },
  "updateBeneficiaryActivity": {
    "functionName": "updateBeneficiaryActivity",
    "path": "https://prod.apistayopen.com/beneficiaries/:beneficiaryId/activity",
    "verb": "POST",
    "authType": "JWT"
  },
  "updateBeneficiaryRestrictedSettings": {
    "functionName": "updateBeneficiaryRestrictedSettings",
    "path": "https://prod.apistayopen.com/beneficiaries/:beneficiaryId/update-restricted-settings",
    "verb": "POST",
    "authType": "JWT"
  },
  "updateBeneficiaryEmailForAgency": {
    "functionName": "updateBeneficiaryEmailForAgency",
    "path": "https://prod.apistayopen.com/agencies/:agencyId/beneficiaries/:beneficiaryId/email/update",
    "verb": "POST",
    "authType": "JWT"
  },
  "updateBeneficiaryIbanForAgency": {
    "functionName": "updateBeneficiaryIbanForAgency",
    "path": "https://prod.apistayopen.com/agencies/:agencyId/beneficiaries/:beneficiaryId/iban/update",
    "verb": "POST",
    "authType": "JWT"
  },
  "updateBeneficiaryMode": {
    "functionName": "updateBeneficiaryMode",
    "path": "https://prod.apistayopen.com/beneficiaries/:beneficiaryId/update-mode",
    "verb": "POST",
    "authType": "JWT"
  },
  "updateBeneficiaryPan": {
    "functionName": "updateBeneficiaryPan",
    "path": "https://prod.apistayopen.com/beneficiaries/:beneficiaryId/pans/:panId/update",
    "verb": "POST",
    "authType": "JWT"
  },
  "updateBeneficiaryRef": {
    "functionName": "updateBeneficiaryRef",
    "path": "https://prod.apistayopen.com/agencies/:agencyId/beneficiaries/:beneficiaryId/ref",
    "verb": "POST",
    "authType": "JWT"
  },
  "updateIbanBeneficiary": {
    "functionName": "updateIbanBeneficiary",
    "path": "https://prod.apistayopen.com/beneficiaries/:beneficiaryId/iban",
    "verb": "POST",
    "authType": "JWT"
  },
  "uploadBeneficiaries": {
    "functionName": "uploadBeneficiaries",
    "path": "https://prod.apistayopen.com/agencies/:agencyId/beneficiaries/upload",
    "verb": "POST",
    "authType": "JWT"
  },
  "getBeneficiaryPaymentInformation": {
    "functionName": "getBeneficiaryPaymentInformation",
    "path": "https://prod.apistayopen.com/beneficiaries/:beneficiaryId/payment-information",
    "verb": "GET",
    "authType": "JWT"
  },
  "updateBeneficiariesClassification": {
    "functionName": "updateBeneficiariesClassification",
    "path": "https://prod.apistayopen.com/beneficiaries/update-classification",
    "verb": "POST",
    "authType": "JWT"
  },
  "associateBeneficiariesWithManagementUnit": {
    "functionName": "associateBeneficiariesWithManagementUnit",
    "path": "https://prod.apistayopen.com/beneficiaries/management-units/associate",
    "verb": "POST",
    "authType": "JWT"
  },
  "updateBeneficiarySettings": {
    "functionName": "updateBeneficiarySettings",
    "path": "https://prod.apistayopen.com/beneficiaries/:beneficiaryId/settings",
    "verb": "POST",
    "authType": "JWT"
  },
  "getBeneficiaryYearlyRecap": {
    "functionName": "getBeneficiaryYearlyRecap",
    "path": "https://prod.apistayopen.com/beneficiaries/yearly-recap",
    "verb": "POST",
    "authType": "JWT"
  },
  "getAgencyInvoices": {
    "functionName": "getAgencyInvoices",
    "path": "https://prod.apistayopen.com/agencies/:agencyId/invoices",
    "verb": "POST",
    "authType": "JWT"
  },
  "getInvoiceBeneficiariesByDate": {
    "functionName": "getInvoiceBeneficiariesByDate",
    "path": "https://prod.apistayopen.com/agencies/:agencyId/invoices/beneficiaries",
    "verb": "POST",
    "authType": "JWT"
  },
  "cleanDatabases": {
    "functionName": "cleanDatabases",
    "path": "https://prod.apistayopen.com/clean-databases",
    "verb": "POST",
    "authType": "JWT"
  },
  "getFeatureFlags": {
    "functionName": "getFeatureFlags",
    "path": "https://prod.apistayopen.com/config/feature-flags",
    "verb": "POST",
    "authType": "NONE"
  },
  "logMobile": {
    "functionName": "logMobile",
    "path": "https://prod.apistayopen.com/maintenance/logMobile",
    "verb": "POST",
    "authType": "NONE"
  },
  "maintenance": {
    "functionName": "maintenance",
    "path": "https://prod.apistayopen.com/maintenance",
    "verb": "POST",
    "authType": "JWT"
  },
  "startMillesimeExecution": {
    "functionName": "startMillesimeExecution",
    "path": "https://prod.apistayopen.com/millesime/start-execution",
    "verb": "POST",
    "authType": "JWT"
  },
  "getCurrentMillesimeMetadata": {
    "functionName": "getCurrentMillesimeMetadata",
    "path": "https://prod.apistayopen.com/millesime/metadata",
    "verb": "POST",
    "authType": "JWT"
  },
  "getAgenciesOptionsForCurrentMillesime": {
    "functionName": "getAgenciesOptionsForCurrentMillesime",
    "path": "https://prod.apistayopen.com/millesime/agencies",
    "verb": "POST",
    "authType": "JWT"
  },
  "getAgencyCurrentMillesimeStatus": {
    "functionName": "getAgencyCurrentMillesimeStatus",
    "path": "https://prod.apistayopen.com/millesime/agencies/:agencyId/contracts/:contractId/status",
    "verb": "GET",
    "authType": "JWT"
  },
  "setAgencyRightsReconductionType": {
    "functionName": "setAgencyRightsReconductionType",
    "path": "https://prod.apistayopen.com/millesime/agencies/:agencyId/contracts/:contractId/rights-reconduction",
    "verb": "POST",
    "authType": "JWT"
  },
  "resetAgencyRightsReconductionType": {
    "functionName": "resetAgencyRightsReconductionType",
    "path": "https://prod.apistayopen.com/millesime/agencies/:agencyId/contracts/:contractId/rights-reconduction/reset",
    "verb": "POST",
    "authType": "JWT"
  },
  "getAgencyMillesimeReports": {
    "functionName": "getAgencyMillesimeReports",
    "path": "https://prod.apistayopen.com/millesime/agencies/:agencyId/reports",
    "verb": "POST",
    "authType": "JWT"
  },
  "getAgencyBeneficiariesMillesimeReports": {
    "functionName": "getAgencyBeneficiariesMillesimeReports",
    "path": "https://prod.apistayopen.com/millesime/agencies/:agencyId/contracts/:contractId/beneficiaries-reports",
    "verb": "POST",
    "authType": "JWT"
  },
  "addSyncedBankAccounts": {
    "functionName": "addSyncedBankAccounts",
    "path": "https://prod.apistayopen.com/beneficiaries/:beneficiaryId/bank-accounts/add-sync",
    "verb": "POST",
    "authType": "JWT"
  },
  "forceToHandleLastPaybacks": {
    "functionName": "forceToHandleLastPaybacks",
    "path": "https://prod.apistayopen.com/beneficiaries/:beneficiaryId/paybacks/force-to-handle",
    "verb": "POST",
    "authType": "JWT"
  },
  "getAvailableBankAccounts": {
    "functionName": "getAvailableBankAccounts",
    "path": "https://prod.apistayopen.com/beneficiaries/:beneficiaryId/bank-accounts",
    "verb": "GET",
    "authType": "JWT"
  },
  "getSyncedBankAccountStatus": {
    "functionName": "getSyncedBankAccountStatus",
    "path": "https://prod.apistayopen.com/beneficiaries/:beneficiaryId/bank-accounts/sync-status",
    "verb": "GET",
    "authType": "JWT"
  },
  "selectBankAccount": {
    "functionName": "selectBankAccount",
    "path": "https://prod.apistayopen.com/beneficiaries/:beneficiaryId/bank-accounts/:bankAccountId/select",
    "verb": "POST",
    "authType": "JWT"
  },
  "updateSyncedBankAccounts": {
    "functionName": "updateSyncedBankAccounts",
    "path": "https://prod.apistayopen.com/beneficiaries/:beneficiaryId/bank-accounts/update-sync",
    "verb": "POST",
    "authType": "JWT"
  },
  "getAgencyOrderProvision": {
    "functionName": "getAgencyOrderProvision",
    "path": "https://prod.apistayopen.com/agencies/:agencyId/orders/:orderId/provisions",
    "verb": "POST",
    "authType": "JWT"
  },
  "getAgencyOrderProvisionSummary": {
    "functionName": "getAgencyOrderProvisionSummary",
    "path": "https://prod.apistayopen.com/agencies/:agencyId/orders/:orderId/provisions-summary",
    "verb": "GET",
    "authType": "JWT"
  },
  "getBeneficiaryProvisions": {
    "functionName": "getBeneficiaryProvisions",
    "path": "https://prod.apistayopen.com/agencies/:agencyId/beneficiaries/:beneficiaryId/provisions",
    "verb": "POST",
    "authType": "JWT"
  },
  "updateOrderDate": {
    "functionName": "updateOrderDate",
    "path": "https://prod.apistayopen.com/orders/update-date",
    "verb": "POST",
    "authType": "JWT"
  },
  "getPaybacksCountForAdmin": {
    "functionName": "getPaybacksCountForAdmin",
    "path": "https://prod.apistayopen.com/admin/paybacks/count",
    "verb": "POST",
    "authType": "JWT"
  },
  "getBeneficiaryPaybacksCount": {
    "functionName": "getBeneficiaryPaybacksCount",
    "path": "https://prod.apistayopen.com/beneficiaries/:beneficiaryId/paybacks/count",
    "verb": "POST",
    "authType": "JWT"
  },
  "getNewPaybacksCountForMobile": {
    "functionName": "getNewPaybacksCountForMobile",
    "path": "https://prod.apistayopen.com/beneficiaries/:beneficiaryId/paybacks/new-count",
    "verb": "POST",
    "authType": "JWT"
  },
  "resetPaybacksCountForMobile": {
    "functionName": "resetPaybacksCountForMobile",
    "path": "https://prod.apistayopen.com/beneficiaries/:beneficiaryId/paybacks/reset-count",
    "verb": "POST",
    "authType": "JWT"
  },
  "getPaginatedPaybacksForAdmin": {
    "functionName": "getPaginatedPaybacksForAdmin",
    "path": "https://prod.apistayopen.com/admin/paybacks/paginated",
    "verb": "POST",
    "authType": "JWT"
  },
  "getExportingPaybacksForAdmin": {
    "functionName": "getExportingPaybacksForAdmin",
    "path": "https://prod.apistayopen.com/admin/paybacks/export",
    "verb": "POST",
    "authType": "JWT"
  },
  "getOnePaybackForAdmin": {
    "functionName": "getOnePaybackForAdmin",
    "path": "https://prod.apistayopen.com/admin/paybacks/:paybackId",
    "verb": "GET",
    "authType": "JWT"
  },
  "getPaginatedPaybacks": {
    "functionName": "getPaginatedPaybacks",
    "path": "https://prod.apistayopen.com/paybacks/paginated",
    "verb": "POST",
    "authType": "JWT"
  },
  "getBeneficiaryPaybacks": {
    "functionName": "getBeneficiaryPaybacks",
    "path": "https://prod.apistayopen.com/beneficiaries/:beneficiaryId/paybacks/list",
    "verb": "POST",
    "authType": "JWT"
  },
  "getPaybacksForMobile": {
    "functionName": "getPaybacksForMobile",
    "path": "https://prod.apistayopen.com/beneficiaries/:beneficiaryId/paybacks",
    "verb": "GET",
    "authType": "JWT"
  },
  "getBeneficiaryUncategorizedTransactions": {
    "functionName": "getBeneficiaryUncategorizedTransactions",
    "path": "https://prod.apistayopen.com/admin/beneficiaries/:beneficiaryId/transactions/uncategorized",
    "verb": "POST",
    "authType": "JWT"
  },
  "createPaybackForScanCB": {
    "functionName": "createPaybackForScanCB",
    "path": "https://prod.apistayopen.com/beneficiaries/:beneficiaryId/paybacks/create-scan-cb",
    "verb": "POST",
    "authType": "JWT"
  },
  "createPaybackTransaction": {
    "functionName": "createPaybackTransaction",
    "path": "https://prod.apistayopen.com/admin/beneficiaries/:beneficiaryId/paybacks/create-transaction",
    "verb": "POST",
    "authType": "JWT"
  },
  "updatePayback": {
    "functionName": "updatePayback",
    "path": "https://prod.apistayopen.com/paybacks/update",
    "verb": "POST",
    "authType": "JWT"
  },
  "addBusinessToPayback": {
    "functionName": "addBusinessToPayback",
    "path": "https://prod.apistayopen.com/paybacks/add-business",
    "verb": "POST",
    "authType": "JWT"
  },
  "resolvePendingBusinessPaybackByAdmin": {
    "functionName": "resolvePendingBusinessPaybackByAdmin",
    "path": "https://prod.apistayopen.com/admin/beneficiaries/:beneficiaryId/paybacks/:paybackId/resolve-business",
    "verb": "POST",
    "authType": "JWT"
  },
  "rejectPendingBusinessPaybackByAdmin": {
    "functionName": "rejectPendingBusinessPaybackByAdmin",
    "path": "https://prod.apistayopen.com/admin/beneficiaries/:beneficiaryId/paybacks/:paybackId/reject-business",
    "verb": "POST",
    "authType": "JWT"
  },
  "resolvePendingOcrPaybackByAdmin": {
    "functionName": "resolvePendingOcrPaybackByAdmin",
    "path": "https://prod.apistayopen.com/admin/beneficiaries/:beneficiaryId/paybacks/:paybackId/resolve-ocr",
    "verb": "POST",
    "authType": "JWT"
  },
  "rejectPendingOcrPaybackByAdmin": {
    "functionName": "rejectPendingOcrPaybackByAdmin",
    "path": "https://prod.apistayopen.com/admin/beneficiaries/:beneficiaryId/paybacks/:paybackId/reject-ocr",
    "verb": "POST",
    "authType": "JWT"
  },
  "processBeneficiaryPayoutsByAdmin": {
    "functionName": "processBeneficiaryPayoutsByAdmin",
    "path": "https://prod.apistayopen.com/admin/beneficiaries/:beneficiaryId/paybacks/process-payouts",
    "verb": "POST",
    "authType": "JWT"
  },
  "rollbackRejectedPaybackByAdmin": {
    "functionName": "rollbackRejectedPaybackByAdmin",
    "path": "https://prod.apistayopen.com/admin/beneficiaries/:beneficiaryId/paybacks/:paybackId/rollback",
    "verb": "POST",
    "authType": "JWT"
  },
  "moveForwardRejectedPaybackByAdmin": {
    "functionName": "moveForwardRejectedPaybackByAdmin",
    "path": "https://prod.apistayopen.com/admin/beneficiaries/:beneficiaryId/paybacks/:paybackId/move-forward",
    "verb": "POST",
    "authType": "JWT"
  },
  "forcePaymentForRejectedBusinessPaybackByAdmin": {
    "functionName": "forcePaymentForRejectedBusinessPaybackByAdmin",
    "path": "https://prod.apistayopen.com/admin/beneficiaries/:beneficiaryId/paybacks/:paybackId/force-payment",
    "verb": "POST",
    "authType": "JWT"
  },
  "handlePendingSelectionPaybackByBeneficiary": {
    "functionName": "handlePendingSelectionPaybackByBeneficiary",
    "path": "https://prod.apistayopen.com/paybacks/handle-pending-selection",
    "verb": "POST",
    "authType": "JWT"
  },
  "getAgencyPayinReports": {
    "functionName": "getAgencyPayinReports",
    "path": "https://prod.apistayopen.com/agencies/:agencyId/payins/reports",
    "verb": "POST",
    "authType": "JWT"
  },
  "getAgencyPayins": {
    "functionName": "getAgencyPayins",
    "path": "https://prod.apistayopen.com/agencies/:agencyId/payins",
    "verb": "GET",
    "authType": "JWT"
  },
  "getPayinsByorderId": {
    "functionName": "getPayinsByorderId",
    "path": "https://prod.apistayopen.com/orders/:orderId/payins",
    "verb": "GET",
    "authType": "JWT"
  },
  "processPayinRefund": {
    "functionName": "processPayinRefund",
    "path": "https://prod.apistayopen.com/payins/:payinId/refund",
    "verb": "POST",
    "authType": "JWT"
  },
  "replayFailedPayin": {
    "functionName": "replayFailedPayin",
    "path": "https://prod.apistayopen.com/payins/:payinId/replay",
    "verb": "POST",
    "authType": "JWT"
  },
  "addBeneficiaryPushToken": {
    "functionName": "addBeneficiaryPushToken",
    "path": "https://prod.apistayopen.com/notifications/beneficiaries/:beneficiaryId/add-token",
    "verb": "POST",
    "authType": "JWT"
  },
  "sendPushNotificationToBeneficiary": {
    "functionName": "sendPushNotificationToBeneficiary",
    "path": "https://prod.apistayopen.com/beneficiaries/push-notification",
    "verb": "POST",
    "authType": "JWT"
  },
  "createMaskPaymentDescriptor": {
    "functionName": "createMaskPaymentDescriptor",
    "path": "https://prod.apistayopen.com/admin/referential-actions/:agencyUid/:listType/create",
    "verb": "POST",
    "authType": "JWT"
  },
  "deleteMaskPaymentDescriptor": {
    "functionName": "deleteMaskPaymentDescriptor",
    "path": "https://prod.apistayopen.com/admin/referential-actions/delete-mask",
    "verb": "POST",
    "authType": "JWT"
  },
  "getCountPaymentDescriptor": {
    "functionName": "getCountPaymentDescriptor",
    "path": "https://prod.apistayopen.com/admin/referential-actions/:agencyUid/count",
    "verb": "GET",
    "authType": "JWT"
  },
  "getOneMaskPaymentDescriptor": {
    "functionName": "getOneMaskPaymentDescriptor",
    "path": "https://prod.apistayopen.com/admin/referential-actions/:agencyUid/:listType/get-one-mask",
    "verb": "POST",
    "authType": "JWT"
  },
  "getListPaymentDescriptor": {
    "functionName": "getListPaymentDescriptor",
    "path": "https://prod.apistayopen.com/admin/referential-actions/:agencyUid/:listType/list",
    "verb": "POST",
    "authType": "JWT"
  },
  "updateMaskPaymentDescriptor": {
    "functionName": "updateMaskPaymentDescriptor",
    "path": "https://prod.apistayopen.com/admin/referential-actions/:agencyUid/:listType/update-mask",
    "verb": "POST",
    "authType": "JWT"
  },
  "createOpenAdmin": {
    "functionName": "createOpenAdmin",
    "path": "https://prod.apistayopen.com/users/create-open-admin",
    "verb": "POST",
    "authType": "JWT"
  },
  "editUserRole": {
    "functionName": "editUserRole",
    "path": "https://prod.apistayopen.com/users/edit-role",
    "verb": "POST",
    "authType": "JWT"
  },
  "getAllUsers": {
    "functionName": "getAllUsers",
    "path": "https://prod.apistayopen.com/users/all",
    "verb": "POST",
    "authType": "JWT"
  },
  "getUserById": {
    "functionName": "getUserById",
    "path": "https://prod.apistayopen.com/users/:userId/get-one",
    "verb": "GET",
    "authType": "JWT"
  },
  "getUserByToken": {
    "functionName": "getUserByToken",
    "path": "https://prod.apistayopen.com/users/get-by-token",
    "verb": "POST",
    "authType": "JWT"
  },
  "updateUserEmail": {
    "functionName": "updateUserEmail",
    "path": "https://prod.apistayopen.com/users/:userId/update-email",
    "verb": "POST",
    "authType": "JWT"
  },
  "getAllVat": {
    "functionName": "getAllVat",
    "path": "https://prod.apistayopen.com/vat/rates",
    "verb": "GET",
    "authType": "JWT"
  },
  "isSundayOrPublicHoliday": {
    "functionName": "isSundayOrPublicHoliday",
    "path": "https://prod.apistayopen.com/calendar/is-sunday-or-holiday",
    "verb": "POST",
    "authType": "NONE"
  },
  "getCountryFlags": {
    "functionName": "getCountryFlags",
    "path": "https://prod.apistayopen.com/country-flags",
    "verb": "GET",
    "authType": "NONE"
  },
  "processBeneficiaryDeactivation": {
    "functionName": "processBeneficiaryDeactivation",
    "path": "https://prod.apistayopen.com/tasks/processBeneficiaryDeactivation",
    "verb": "POST",
    "authType": "NONE"
  },
  "getBusinessInfo": {
    "functionName": "getBusinessInfo",
    "path": "https://prod.apistayopen.com/businesses/:identifier/infos",
    "verb": "GET",
    "authType": "JWT"
  },
  "searchBusinessByCriteria": {
    "functionName": "searchBusinessByCriteria",
    "path": "https://prod.apistayopen.com/businesses/search-by-criteria",
    "verb": "POST",
    "authType": "JWT"
  },
  "searchPappersBusinesses": {
    "functionName": "searchPappersBusinesses",
    "path": "https://prod.apistayopen.com/businesses/search-pappers",
    "verb": "POST",
    "authType": "JWT"
  },
  "getAllBusinessesWithPagination": {
    "functionName": "getAllBusinessesWithPagination",
    "path": "https://prod.apistayopen.com/businesses/all",
    "verb": "POST",
    "authType": "JWT"
  },
  "createOneBusiness": {
    "functionName": "createOneBusiness",
    "path": "https://prod.apistayopen.com/businesses/create",
    "verb": "POST",
    "authType": "JWT"
  },
  "createOneBusinessFromSiret": {
    "functionName": "createOneBusinessFromSiret",
    "path": "https://prod.apistayopen.com/businesses/create-from-siret",
    "verb": "POST",
    "authType": "JWT"
  },
  "updateOneBusiness": {
    "functionName": "updateOneBusiness",
    "path": "https://prod.apistayopen.com/businesses/:businessId/update",
    "verb": "POST",
    "authType": "JWT"
  },
  "getAllContractByBusinessId": {
    "functionName": "getAllContractByBusinessId",
    "path": "https://prod.apistayopen.com/businesses/:businessId/contracts",
    "verb": "GET",
    "authType": "JWT"
  },
  "createOneContract": {
    "functionName": "createOneContract",
    "path": "https://prod.apistayopen.com/businesses/:businessId/contracts/create",
    "verb": "POST",
    "authType": "JWT"
  },
  "updateOneContract": {
    "functionName": "updateOneContract",
    "path": "https://prod.apistayopen.com/businesses/:businessId/contracts/:contractId/update",
    "verb": "POST",
    "authType": "JWT"
  },
  "deleteOneContract": {
    "functionName": "deleteOneContract",
    "path": "https://prod.apistayopen.com/businesses/:businessId/contracts/:contractId/delete",
    "verb": "POST",
    "authType": "JWT"
  },
  "getOneBusinessInvoices": {
    "functionName": "getOneBusinessInvoices",
    "path": "https://prod.apistayopen.com/business/:businessId/invoices",
    "verb": "GET",
    "authType": "JWT"
  },
  "getBusinessBillingInfo": {
    "functionName": "getBusinessBillingInfo",
    "path": "https://prod.apistayopen.com/businesses/billing",
    "verb": "POST",
    "authType": "JWT"
  },
  "launchBilling": {
    "functionName": "launchBilling",
    "path": "https://prod.apistayopen.com/businesses/billing/launch",
    "verb": "POST",
    "authType": "JWT"
  },
  "getBusinessesUser": {
    "functionName": "getBusinessesUser",
    "path": "https://prod.apistayopen.com/businesses/:businessId/users",
    "verb": "GET",
    "authType": "JWT"
  },
  "createOrUpdateBusinessAdminOrCashier": {
    "functionName": "createOrUpdateBusinessAdminOrCashier",
    "path": "https://prod.apistayopen.com/businesses/:businessId/users/upsert",
    "verb": "POST",
    "authType": "JWT"
  },
  "sendBusinessUserResetPassword": {
    "functionName": "sendBusinessUserResetPassword",
    "path": "https://prod.apistayopen.com/businesses/users/reset-password",
    "verb": "POST",
    "authType": "JWT"
  },
  "initiateDiscreteContractBetweenAgencyAndBusiness": {
    "functionName": "initiateDiscreteContractBetweenAgencyAndBusiness",
    "path": "https://prod.apistayopen.com/contracted-businesses/initiate",
    "verb": "POST",
    "authType": "JWT"
  },
  "updateDiscreteContractBetweenAgencyAndBusiness": {
    "functionName": "updateDiscreteContractBetweenAgencyAndBusiness",
    "path": "https://prod.apistayopen.com/contracted-businesses/update",
    "verb": "POST",
    "authType": "JWT"
  },
  "getLatestBalance": {
    "functionName": "getLatestBalance",
    "path": "https://prod.apistayopen.com/balances/latest",
    "verb": "POST",
    "authType": "JWT"
  },
  "calculateRemainingRightsForPeriod": {
    "functionName": "calculateRemainingRightsForPeriod",
    "path": "https://prod.apistayopen.com/balances/remaining-rights",
    "verb": "POST",
    "authType": "JWT"
  },
  "insertBalance": {
    "functionName": "insertBalance",
    "path": "https://prod.apistayopen.com/balances/insert",
    "verb": "POST",
    "authType": "JWT"
  },
  "refreshBalances": {
    "functionName": "refreshBalances",
    "path": "https://prod.apistayopen.com/balances/refresh",
    "verb": "POST",
    "authType": "JWT"
  },
  "documentSignatureFlow": {
    "functionName": "documentSignatureFlow",
    "path": "https://prod.apistayopen.com/documents/signature_flow",
    "verb": "POST",
    "authType": "JWT"
  },
  "webhookDocument": {
    "functionName": "webhookDocument",
    "path": "https://prod.apistayopen.com/documents/webhook",
    "verb": "POST",
    "authType": "JWT"
  },
  "getAgencyPaymentTransactions": {
    "functionName": "getAgencyPaymentTransactions",
    "path": "https://prod.apistayopen.com/companies/:companyId/agencies/:agencyId/payment-transactions",
    "verb": "POST",
    "authType": "JWT"
  },
  "getBeneficiaryPaymentTransactions": {
    "functionName": "getBeneficiaryPaymentTransactions",
    "path": "https://prod.apistayopen.com/beneficiaries/:beneficiaryId/payment-transactions",
    "verb": "POST",
    "authType": "JWT"
  },
  "updatePaymentTransactionVerificationStatus": {
    "functionName": "updatePaymentTransactionVerificationStatus",
    "path": "https://prod.apistayopen.com/payment-transactions/:paymentTransactionId/verification-status",
    "verb": "PUT",
    "authType": "JWT"
  },
  "getPaymentTransactionsCountForAgencyWallet": {
    "functionName": "getPaymentTransactionsCountForAgencyWallet",
    "path": "https://prod.apistayopen.com/companies/:companyId/agencies/:agencyId/payment-transactions/count",
    "verb": "POST",
    "authType": "JWT"
  }
} as const;